module.exports = __webpack_public_path__ + "static/media/elva@2x.4384a55f.png";